export default __webpack_public_path__ + "static/Metal_Double_Doorframe-7f68a9fc9cac29ede5c315997cdb32f7.png";